import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Question, QuestionResponseResult, QuestionType, Survey } from '../../types';

interface SurveyState {
    survey: Survey;
}

const initialState: SurveyState = {
    survey: {
        id: '',
        title: '',
        description: '',
        questions: [],
        responses: [],
        creator: '',
        createdAt: new Date(),
        updatedAt: new Date(),
    }
}

export const SurveySlice = createSlice({
    name: 'survey',
    initialState,
    reducers: {
        createSurvey: (state, action: PayloadAction<Survey>) => {
            state.survey = action.payload;
        },
        removeSurvey: (state) => {
            state.survey = {
                id: '',
                title: '',
                description: '',
                questions: [],
                responses: [],
                creator: '',
                createdAt: new Date(),
                updatedAt: new Date(),
            }
        },
        resetSurvey: (state) => {
            state.survey = initialState.survey;
        },
        addQuestion: (state, action: PayloadAction<{question: Question, response: QuestionResponseResult}>) => {
            state.survey.questions.push(action.payload.question);
            state.survey.responses.push({questionText: action.payload.question.questionText, questionId: action.payload.question.id, questionType: action.payload.question.type, results: []});
        },
        deleteQuestion: (state, action: PayloadAction<Question>) => {
            state.survey.questions = state.survey.questions.filter(question => question.id !== action.payload.id);
            state.survey.responses = state.survey.responses.filter(response => response.questionId !== action.payload.id);
        },
        updateQuestion: (state, action: PayloadAction<Question>) => {
            state.survey.questions = state.survey.questions.map(question => question.id === action.payload.id ? action.payload : question);
        }
    }
});

export default SurveySlice.reducer;

export const { createSurvey, removeSurvey, resetSurvey, addQuestion, deleteQuestion, updateQuestion } = SurveySlice.actions;